export default "/images/7ba0e56aa9d93ac44dd098e380e2e38f.avif";